// This file is auto-generated by the generate:translations task. Do not edit directly.

enum FormsKeys {
  General_Optional = 'forms:general.optional',
  Defaults_Messages_DeliveryOptionRequired = 'forms:defaults.messages.deliveryOptionRequired',
  Defaults_Messages_FormHasErrors = 'forms:defaults.messages.formHasErrors',
  Defaults_Messages_FormatZip = 'forms:defaults.messages.formatZip',
  Defaults_Messages_FormatCardId = 'forms:defaults.messages.format_cardId',
  Defaults_Messages_FormatContactnumber = 'forms:defaults.messages.format_contactnumber',
  Defaults_Messages_FormatEmail = 'forms:defaults.messages.format_email',
  Defaults_Messages_FormatPasswordDuplicate = 'forms:defaults.messages.format_password_duplicate',
  Defaults_Messages_FormatPasswordLowerCase = 'forms:defaults.messages.format_password_lowerCase',
  Defaults_Messages_FormatPasswordLowerCaseHint = 'forms:defaults.messages.format_password_lowerCase_hint',
  Defaults_Messages_FormatPasswordMinLength = 'forms:defaults.messages.format_password_minLength',
  Defaults_Messages_FormatPasswordMinLengthHint = 'forms:defaults.messages.format_password_minLength_hint',
  Defaults_Messages_FormatPasswordNumberHint = 'forms:defaults.messages.format_password_number_hint',
  Defaults_Messages_FormatPasswordRepeat = 'forms:defaults.messages.format_password_repeat',
  Defaults_Messages_FormatPasswordUpperCase = 'forms:defaults.messages.format_password_upperCase',
  Defaults_Messages_FormatPasswordUpperCaseHint = 'forms:defaults.messages.format_password_upperCase_hint',
  Defaults_Messages_FormatPatientId = 'forms:defaults.messages.format_patientId',
  Defaults_Messages_FormatUsername = 'forms:defaults.messages.format_username',
  Defaults_Messages_FormatUsernameHint = 'forms:defaults.messages.format_username_hint',
  Defaults_Messages_InsuranceNumberDoesNotMatch = 'forms:defaults.messages.insuranceNumberDoesNotMatch',
  Defaults_Messages_InvalidAmount = 'forms:defaults.messages.invalidAmount',
  Defaults_Messages_InvalidCumulusId = 'forms:defaults.messages.invalidCumulusId',
  Defaults_Messages_InvalidIntakeDayEntered = 'forms:defaults.messages.invalidIntakeDayEntered',
  Defaults_Messages_InvalidPromotion = 'forms:defaults.messages.invalidPromotion',
  Defaults_Messages_MoreThanZero = 'forms:defaults.messages.moreThanZero',
  Defaults_Messages_NoLettersMayBeEntered = 'forms:defaults.messages.noLettersMayBeEntered',
  Defaults_Messages_PhoneInvalidCharacters = 'forms:defaults.messages.phoneInvalidCharacters',
  Defaults_Messages_PhoneInvalidLength = 'forms:defaults.messages.phoneInvalidLength',
  Defaults_Messages_PhoneMustHavePreDial = 'forms:defaults.messages.phoneMustHavePreDial',
  Defaults_Messages_PhonePurposeMessage = 'forms:defaults.messages.phonePurposeMessage',
  Defaults_Messages_PromotionExpired = 'forms:defaults.messages.promotionExpired',
  Defaults_Messages_RequiredField = 'forms:defaults.messages.requiredField',
  Defaults_Labels_ActualMobilePhone = 'forms:defaults.labels.actualMobilePhone',
  Defaults_Labels_AdditionalAddressLine = 'forms:defaults.labels.additionalAddressLine',
  Defaults_Labels_Birthdate = 'forms:defaults.labels.birthdate',
  Defaults_Labels_Canton = 'forms:defaults.labels.canton',
  Defaults_Labels_CardId = 'forms:defaults.labels.cardId',
  Defaults_Labels_CheckboxOthers = 'forms:defaults.labels.checkboxOthers',
  Defaults_Labels_City = 'forms:defaults.labels.city',
  Defaults_Labels_Comment = 'forms:defaults.labels.comment',
  Defaults_Labels_Company = 'forms:defaults.labels.company',
  Defaults_Labels_ContactMessage = 'forms:defaults.labels.contactMessage',
  Defaults_Labels_ContactPrev = 'forms:defaults.labels.contactPrev',
  Defaults_Labels_Country = 'forms:defaults.labels.country',
  Defaults_Labels_Cumulus = 'forms:defaults.labels.cumulus',
  Defaults_Labels_DeliveryAddress = 'forms:defaults.labels.deliveryAddress',
  Defaults_Labels_DeliveryDate = 'forms:defaults.labels.deliveryDate',
  Defaults_Labels_Email = 'forms:defaults.labels.email',
  Defaults_Labels_EndDate = 'forms:defaults.labels.endDate',
  Defaults_Labels_Evening = 'forms:defaults.labels.evening',
  Defaults_Labels_Fax = 'forms:defaults.labels.fax',
  Defaults_Labels_Firstname = 'forms:defaults.labels.firstname',
  Defaults_Labels_Generic = 'forms:defaults.labels.generic',
  Defaults_Labels_GenericDrugAddition = 'forms:defaults.labels.genericDrugAddition',
  Defaults_Labels_GenericDrugAddition2 = 'forms:defaults.labels.genericDrugAddition2',
  Defaults_Labels_HealthInsurance = 'forms:defaults.labels.healthInsurance',
  Defaults_Labels_HealthInsuranceAdditional = 'forms:defaults.labels.healthInsuranceAdditional',
  Defaults_Labels_HealthInsuranceAdditionalNumber = 'forms:defaults.labels.healthInsuranceAdditionalNumber',
  Defaults_Labels_HealthInsuranceNumber = 'forms:defaults.labels.healthInsuranceNumber',
  Defaults_Labels_IntakeDuration = 'forms:defaults.labels.intakeDuration',
  Defaults_Labels_IntakeFrequency = 'forms:defaults.labels.intakeFrequency',
  Defaults_Labels_IntakeTime = 'forms:defaults.labels.intakeTime',
  Defaults_Labels_Lastname = 'forms:defaults.labels.lastname',
  Defaults_Labels_MediPlusActivationCodeMax6 = 'forms:defaults.labels.mediPlusActivationCodeMax6',
  Defaults_Labels_MedicationPlanDate = 'forms:defaults.labels.medicationPlanDate',
  Defaults_Labels_MedicationReminderEmail = 'forms:defaults.labels.medicationReminderEmail',
  Defaults_Labels_MedicationReminderMobilePhone = 'forms:defaults.labels.medicationReminderMobilePhone',
  Defaults_Labels_MfaVerificationCode = 'forms:defaults.labels.mfaVerificationCode',
  Defaults_Labels_Midday = 'forms:defaults.labels.midday',
  Defaults_Labels_Minutes = 'forms:defaults.labels.minutes',
  Defaults_Labels_MobileNumber = 'forms:defaults.labels.mobileNumber',
  Defaults_Labels_Name = 'forms:defaults.labels.name',
  Defaults_Labels_NewMobilePhone = 'forms:defaults.labels.newMobilePhone',
  Defaults_Labels_Night = 'forms:defaults.labels.night',
  Defaults_Labels_Note = 'forms:defaults.labels.note',
  Defaults_Labels_Original = 'forms:defaults.labels.original',
  Defaults_Labels_OtherAllergies = 'forms:defaults.labels.otherAllergies',
  Defaults_Labels_OtherDiseases = 'forms:defaults.labels.otherDiseases',
  Defaults_Labels_OutOfStockHandling = 'forms:defaults.labels.outOfStockHandling',
  Defaults_Labels_Password = 'forms:defaults.labels.password',
  Defaults_Labels_PasswordNew = 'forms:defaults.labels.passwordNew',
  Defaults_Labels_PasswordNewRepeat = 'forms:defaults.labels.passwordNewRepeat',
  Defaults_Labels_PasswordOld = 'forms:defaults.labels.passwordOld',
  Defaults_Labels_Phone = 'forms:defaults.labels.phone',
  Defaults_Labels_PickPostFilialId = 'forms:defaults.labels.pickPostFilialId',
  Defaults_Labels_PickPostUserId = 'forms:defaults.labels.pickPostUserId',
  Defaults_Labels_Postalcode = 'forms:defaults.labels.postalcode',
  Defaults_Labels_PregnancyDueDate = 'forms:defaults.labels.pregnancyDueDate',
  Defaults_Labels_PromotionCode = 'forms:defaults.labels.promotionCode',
  Defaults_Labels_Salutation = 'forms:defaults.labels.salutation',
  Defaults_Labels_SearchDoctor = 'forms:defaults.labels.searchDoctor',
  Defaults_Labels_SearchMedicine = 'forms:defaults.labels.searchMedicine',
  Defaults_Labels_SearchMedicineShort = 'forms:defaults.labels.searchMedicineShort',
  Defaults_Labels_SelectedLang = 'forms:defaults.labels.selectedLang',
  Defaults_Labels_StartDate = 'forms:defaults.labels.startDate',
  Defaults_Labels_Street = 'forms:defaults.labels.street',
  Defaults_Labels_Subject = 'forms:defaults.labels.subject',
  Defaults_Labels_Tel_Business = 'forms:defaults.labels.tel.business',
  Defaults_Labels_Tel_Mobile = 'forms:defaults.labels.tel.mobile',
  Defaults_Labels_Tel_Private = 'forms:defaults.labels.tel.private',
  Defaults_Labels_Time = 'forms:defaults.labels.time',
  Defaults_Labels_Title = 'forms:defaults.labels.title',
  Defaults_Labels_Tomorrow = 'forms:defaults.labels.tomorrow',
  Defaults_Labels_Unit = 'forms:defaults.labels.unit',
  Defaults_Labels_UsernameOrCustomerId = 'forms:defaults.labels.usernameOrCustomerId',
  Messages_InvalidDate = 'forms:messages.invalidDate',
  Messages_InvalidMonth = 'forms:messages.invalidMonth',
  Messages_InvalidDay = 'forms:messages.invalidDay',
  Messages_NoPickPostAllowed = 'forms:messages.noPickPostAllowed',
  Messages_RequiredEmail = 'forms:messages.required_email',
  Messages_RequiredBirthdate = 'forms:messages.required_birthdate',
  Messages_SavingSuccessful = 'forms:messages.savingSuccessful',
  Messages_MfaSetupSuccess = 'forms:messages.mfaSetupSuccess',
  Messages_ErrorChangeUsername = 'forms:messages.errorChangeUsername',
  Messages_ErrorChangePassword = 'forms:messages.errorChangePassword',
  Messages_ErrorPasswordNoChange = 'forms:messages.errorPasswordNoChange',
  ResetPassword_Messages_ErrorResetPassword = 'forms:resetPassword.messages.errorResetPassword',
  ResetPassword_Messages_ErrorTokenResetPassword = 'forms:resetPassword.messages.errorTokenResetPassword',
  Mfa_ConfirmMfa = 'forms:mfa.confirmMfa',
  Mfa_SaveMobileNumber = 'forms:mfa.saveMobileNumber',
  Mfa_ConfigureLater = 'forms:mfa.configureLater',
  Mfa_InvalidTan = 'forms:mfa.invalidTan',
  Mfa_ConfirmMfaDescription = 'forms:mfa.confirmMfaDescription',
  Mfa_ConfirmMfaAccordionTitle = 'forms:mfa.confirmMfaAccordionTitle',
  Mfa_ConfirmMfaAccordionButton = 'forms:mfa.confirmMfaAccordionButton',
  Mfa_ConfirmMfaAccordionContent = 'forms:mfa.confirmMfaAccordionContent',
  Mfa_ProtectYourAccountWithAConfirmationCode = 'forms:mfa.protectYourAccountWithAConfirmationCode',
  Mfa_Benefits_IncreasedSecurityOfHealthData = 'forms:mfa.benefits.increasedSecurityOfHealthData',
  Mfa_Benefits_NotificationOfUnknownAccessAttempt = 'forms:mfa.benefits.notificationOfUnknownAccessAttempt',
  Mfa_Benefits_NotificationSetupMFATitle = 'forms:mfa.benefits.notificationSetupMFATitle',
  Mfa_Benefits_NotificationSetupMFADescription = 'forms:mfa.benefits.notificationSetupMFADescription',
  Mfa_Benefits_NotificationSetupMFAButtonTitleNo = 'forms:mfa.benefits.notificationSetupMFAButtonTitleNo',
  Mfa_ModifyMfa = 'forms:mfa.modifyMfa',
  Mfa_DisableMFA = 'forms:mfa.disableMFA',
  Mfa_NotRecommended = 'forms:mfa.notRecommended',
  Register_Messages_CustomerNotValidOrNotExist = 'forms:register.messages.customerNotValidOrNotExist',
  Cumulus_Description = 'forms:cumulus.description',
  Dailymed_Labels_ChooseMedi = 'forms:dailymed.labels.chooseMedi',
  Checkout_Labels_DeliverySchedule = 'forms:checkout.labels.deliverySchedule',
  Checkout_Labels_CommentDelivery = 'forms:checkout.labels.commentDelivery',
}
type FormsKey =
  | 'general.optional'
  | 'defaults.messages.deliveryOptionRequired'
  | 'defaults.messages.formHasErrors'
  | 'defaults.messages.formatZip'
  | 'defaults.messages.format_cardId'
  | 'defaults.messages.format_contactnumber'
  | 'defaults.messages.format_email'
  | 'defaults.messages.format_password_duplicate'
  | 'defaults.messages.format_password_lowerCase'
  | 'defaults.messages.format_password_lowerCase_hint'
  | 'defaults.messages.format_password_minLength'
  | 'defaults.messages.format_password_minLength_hint'
  | 'defaults.messages.format_password_number_hint'
  | 'defaults.messages.format_password_repeat'
  | 'defaults.messages.format_password_upperCase'
  | 'defaults.messages.format_password_upperCase_hint'
  | 'defaults.messages.format_patientId'
  | 'defaults.messages.format_username'
  | 'defaults.messages.format_username_hint'
  | 'defaults.messages.insuranceNumberDoesNotMatch'
  | 'defaults.messages.invalidAmount'
  | 'defaults.messages.invalidCumulusId'
  | 'defaults.messages.invalidIntakeDayEntered'
  | 'defaults.messages.invalidPromotion'
  | 'defaults.messages.moreThanZero'
  | 'defaults.messages.noLettersMayBeEntered'
  | 'defaults.messages.phoneInvalidCharacters'
  | 'defaults.messages.phoneInvalidLength'
  | 'defaults.messages.phoneMustHavePreDial'
  | 'defaults.messages.phonePurposeMessage'
  | 'defaults.messages.promotionExpired'
  | 'defaults.messages.requiredField'
  | 'defaults.labels.actualMobilePhone'
  | 'defaults.labels.additionalAddressLine'
  | 'defaults.labels.birthdate'
  | 'defaults.labels.canton'
  | 'defaults.labels.cardId'
  | 'defaults.labels.checkboxOthers'
  | 'defaults.labels.city'
  | 'defaults.labels.comment'
  | 'defaults.labels.company'
  | 'defaults.labels.contactMessage'
  | 'defaults.labels.contactPrev'
  | 'defaults.labels.country'
  | 'defaults.labels.cumulus'
  | 'defaults.labels.deliveryAddress'
  | 'defaults.labels.deliveryDate'
  | 'defaults.labels.email'
  | 'defaults.labels.endDate'
  | 'defaults.labels.evening'
  | 'defaults.labels.fax'
  | 'defaults.labels.firstname'
  | 'defaults.labels.generic'
  | 'defaults.labels.genericDrugAddition'
  | 'defaults.labels.genericDrugAddition2'
  | 'defaults.labels.healthInsurance'
  | 'defaults.labels.healthInsuranceAdditional'
  | 'defaults.labels.healthInsuranceAdditionalNumber'
  | 'defaults.labels.healthInsuranceNumber'
  | 'defaults.labels.intakeDuration'
  | 'defaults.labels.intakeFrequency'
  | 'defaults.labels.intakeTime'
  | 'defaults.labels.lastname'
  | 'defaults.labels.mediPlusActivationCodeMax6'
  | 'defaults.labels.medicationPlanDate'
  | 'defaults.labels.medicationReminderEmail'
  | 'defaults.labels.medicationReminderMobilePhone'
  | 'defaults.labels.mfaVerificationCode'
  | 'defaults.labels.midday'
  | 'defaults.labels.minutes'
  | 'defaults.labels.mobileNumber'
  | 'defaults.labels.name'
  | 'defaults.labels.newMobilePhone'
  | 'defaults.labels.night'
  | 'defaults.labels.note'
  | 'defaults.labels.original'
  | 'defaults.labels.otherAllergies'
  | 'defaults.labels.otherDiseases'
  | 'defaults.labels.outOfStockHandling'
  | 'defaults.labels.password'
  | 'defaults.labels.passwordNew'
  | 'defaults.labels.passwordNewRepeat'
  | 'defaults.labels.passwordOld'
  | 'defaults.labels.phone'
  | 'defaults.labels.pickPostFilialId'
  | 'defaults.labels.pickPostUserId'
  | 'defaults.labels.postalcode'
  | 'defaults.labels.pregnancyDueDate'
  | 'defaults.labels.promotionCode'
  | 'defaults.labels.salutation'
  | 'defaults.labels.searchDoctor'
  | 'defaults.labels.searchMedicine'
  | 'defaults.labels.searchMedicineShort'
  | 'defaults.labels.selectedLang'
  | 'defaults.labels.startDate'
  | 'defaults.labels.street'
  | 'defaults.labels.subject'
  | 'defaults.labels.tel.business'
  | 'defaults.labels.tel.mobile'
  | 'defaults.labels.tel.private'
  | 'defaults.labels.time'
  | 'defaults.labels.title'
  | 'defaults.labels.tomorrow'
  | 'defaults.labels.unit'
  | 'defaults.labels.usernameOrCustomerId'
  | 'messages.invalidDate'
  | 'messages.invalidMonth'
  | 'messages.invalidDay'
  | 'messages.noPickPostAllowed'
  | 'messages.required_email'
  | 'messages.required_birthdate'
  | 'messages.savingSuccessful'
  | 'messages.mfaSetupSuccess'
  | 'messages.errorChangeUsername'
  | 'messages.errorChangePassword'
  | 'messages.errorPasswordNoChange'
  | 'resetPassword.messages.errorResetPassword'
  | 'resetPassword.messages.errorTokenResetPassword'
  | 'mfa.confirmMfa'
  | 'mfa.saveMobileNumber'
  | 'mfa.configureLater'
  | 'mfa.invalidTan'
  | 'mfa.confirmMfaDescription'
  | 'mfa.confirmMfaAccordionTitle'
  | 'mfa.confirmMfaAccordionButton'
  | 'mfa.confirmMfaAccordionContent'
  | 'mfa.protectYourAccountWithAConfirmationCode'
  | 'mfa.benefits.increasedSecurityOfHealthData'
  | 'mfa.benefits.notificationOfUnknownAccessAttempt'
  | 'mfa.benefits.notificationSetupMFATitle'
  | 'mfa.benefits.notificationSetupMFADescription'
  | 'mfa.benefits.notificationSetupMFAButtonTitleNo'
  | 'mfa.modifyMfa'
  | 'mfa.disableMFA'
  | 'mfa.notRecommended'
  | 'register.messages.customerNotValidOrNotExist'
  | 'cumulus.description'
  | 'dailymed.labels.chooseMedi'
  | 'checkout.labels.deliverySchedule'
  | 'checkout.labels.commentDelivery';

export { FormsKeys, type FormsKey };
